import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";

const initialState = {
  isLoading: false,
  error: null,
};

export const uploadSitemap = createAsyncThunk(
  "sitemap/upload",
  async ({ data, enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.post("/sitemap/upload", data);
      enqueueSnackbar("Sitemap uploaded successfully");
      return response.data;
    } catch (error) {
      if (enqueueSnackbar) {
        enqueueSnackbar(error.message || "Failed to upload sitemap", {
          variant: "error",
        });
      }
      return thunkApi.rejectWithValue({ error });
    }
  }
);

const sitemapSlice = createSlice({
  name: "sitemap/upload",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(uploadSitemap.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(uploadSitemap.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(uploadSitemap.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.error;
    });
  },
});

export default sitemapSlice.reducer;
